<div class="matrix-with-summary">
    <div class="summary-matrix">
        @for (color of matrix.colors; track color; let i = $index) {
            <div
                class="summary-cell"
                [class.clickable]="summaryClick.observers.length > 0"
                (click)="handleSummaryClick(i)"
                [ngStyle]="{
                    'background-color': color,
                    width:
                        ((cellSize + 2 * cellSpacing) * matrix.impactSize - 2 * cellSpacing) /
                            matrix.colors.length +
                        'px',
                }"
            >
                @if (matrix.summaryContent && matrix.summaryContent[color]) {
                    <div class="cell-value">
                        <span>{{ matrix.summaryContent[color] }}</span>
                    </div>
                }
            </div>
        }
    </div>

    <div class="matrix">
        <cerrix-riskmatrix
            [matrix]="matrix"
            [cellSize]="cellSize"
            [cellSpacing]="cellSpacing"
            [highlightSelection]="false"
            (selectedChange)="handleCellClick($event)"
        ></cerrix-riskmatrix>
    </div>
</div>
